export default __webpack_public_path__ + "static/media/Login2.1fa006ea.svg";